import {Badge, createStyles, Group, Tooltip} from '@mantine/core';
import React from 'react';

import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import {RoutineRunAs} from 'llm/routines/RoutineTypes';
import {ZINDEX_FLOATING_UI} from 'styles/StyleConstants';
import Avatar, {type HasAvatar} from 'ui-library/avatar/Avatar';
import {AvatarSize} from 'ui-library/avatar/AvatarConstants';

const PERSONAL_RUN_AS_BADGE_TOOLTIP = "Agent uses the creator's permissions when it runs";

const useStyles = createStyles(() => ({
  titleMetaGroup: {
    // Avatar renders inside an inline span; zero line-height avoids vertical misalignment.
    lineHeight: 0,
  },
  personalBadge: {
    // `xs` is the smallest Badge size in our design system, but it still reads large next to the sm
    // agent title (same font size). Scale down until we can bump the title size (out of scope here).
    transform: 'scale(0.9)',
  },
}));

export default function AgentListItemTitleMeta({
  creator,
  runAs,
}: {
  creator: HasAvatar | null;
  runAs: RoutineRunAs;
}): JSX.Element | null {
  const {classes} = useStyles();
  const {llmEnableRoutineServiceAccountUi} = useRolloutFlags();

  if (creator == null) {
    return null;
  }

  const showPersonalBadge = llmEnableRoutineServiceAccountUi === true && runAs === RoutineRunAs.CREATOR;

  return (
    <Group spacing={4} noWrap={true} align="center" className={classes.titleMetaGroup}>
      <Avatar size={AvatarSize.XXSMALL} entity={creator} showTooltip={true} />
      {showPersonalBadge && (
        <Tooltip label={PERSONAL_RUN_AS_BADGE_TOOLTIP} withinPortal={true} zIndex={ZINDEX_FLOATING_UI}>
          <Badge
            className={classes.personalBadge}
            color="blue"
            size="xs"
            variant="light"
            radius="sm"
            tt="uppercase"
          >
            Personal
          </Badge>
        </Tooltip>
      )}
    </Group>
  );
}
